import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuthentication from '../../hooks/useAuthentication';

const AuthGuard = ({ children }) => {
  const { isAuthenticated, isBoarding } = useAuthentication();
  console.log("Get the value of the authenticatin in Auth Guard to check ", isAuthenticated, isBoarding)
  if (!isAuthenticated) {
    return <Redirect to="/signin" />;
  }
  else if (isAuthenticated && isBoarding) {
    return <Redirect to="/onBoarding" />;
  }

  return (
    <>
      {children}
    </>
  );
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
